import { defineMessages } from 'react-intl'

export default defineMessages({
  closeSidebar: {
    id: 'components.SidebarLayout.closeSidebar',
    defaultMessage: 'Close sidebar',
  },
  openSidebar: {
    id: 'components.SidebarLayout.openSidebar',
    defaultMessage: 'Open sidebar',
  },
  openNotifications: {
    id: 'components.SidebarLayout.openNotifications',
    defaultMessage: 'Open notifications',
  },
  go: {
    id: 'components.SidebarLayout.go',
    defaultMessage: 'Go',
  },
  openUserMenu: {
    id: 'components.SidebarLayout.openUserMenu',
    defaultMessage: 'Open user menu',
  },
  openAppsMenu: {
    id: 'components.SidebarLayout.openAppsMenu',
    defaultMessage: 'Show all VoiceArchive apps',
  },
  yourProfile: {
    id: 'components.SidebarLayout.yourProfile',
    defaultMessage: 'Your Profile',
  },
  notificationSettings: {
    id: 'components.SidebarLayout.notificationSettings',
    defaultMessage: 'Notification Settings',
  },
  securitySettings: {
    id: 'components.SidebarLayout.securitySettings',
    defaultMessage: 'Security Settings',
  },
  signOut: {
    id: 'components.SidebarLayout.signOut',
    defaultMessage: 'Sign out',
  },
  signedInAs: {
    id: 'components.SidebarLayout.signedInAs',
    defaultMessage: 'Signed in as',
  },
  markSeen: {
    id: 'components.SidebarLayout.markSeen',
    defaultMessage: 'Mark seen',
  },
  companyDetails: {
    id: 'components.SidebarLayout.companyDetails',
    defaultMessage: 'View company details',
  },
  notificationsEmptyState: {
    id: 'components.SidebarLayout.notificationsEmptyState',
    defaultMessage: 'You have no unread notifications',
  },
  appVersion: {
    id: 'components.SidebarLayout.appVersion',
    defaultMessage: 'Ver. {date} {time} ({version})',
  },
})
